import React, { useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import './map.scss';

const CustomG = ({
  mapElement,
  selectedCommunity,
  selectedPlace,
  mouseEnter,
  mouseLeave,
  getWinner,
  clickElement,
  showDots = false
}) => (
  <a href={mapElement.href} onClick={e => clickElement(e, mapElement)}>
    <g
      className={`${mapElement.name} ${mapElement.ineId}`}
      data-hover={
        selectedCommunity
          ? mapElement.parentId === selectedCommunity
            ? true
            : false
          : undefined
      }
      data-selected={
        mapElement.parentId === selectedPlace.ineId ||
        selectedPlace.ineId === mapElement.ineId
      }
      data-sibiling={mapElement.parentId === selectedPlace.parentId}
      onMouseMove={e =>
        mouseEnter(e, {
          ...mapElement,
          ...getWinner(mapElement.ineId)
        })
      }
      onMouseLeave={e =>
        mouseLeave(e, {
          ...mapElement,
          ...getWinner(mapElement.ineId)
        })
      }
    >
      <path
        key={mapElement.ineId}
        className={`mapElement ${mapElement.name} ${mapElement.ineId}`}
        fill={!showDots ? getWinner(mapElement.ineId).partyColor : '#ccc'}
        onClick={e => clickElement(e, mapElement)}
        d={mapElement.svg}
      />
      {showDots && (
        <circle
          xmlns="http://www.w3.org/2000/svg"
          class="st1"
          cx={mapElement.svgDots.x}
          cy={mapElement.svgDots.y}
          r="5"
          fill={
            getWinner(mapElement.ineId).partyColor
              ? getWinner(mapElement.ineId).partyColor
              : '#444'
          }
        />
      )}
    </g>
  </a>
);

const SvgMap = ({
  onClick,
  selected,
  mapElements,
  className,
  viewVoxStyle,
  whenChange,
  partiesWinners,
  currentCommunity,
  allRegions,
  selectedPlace,
  native,
  showDots = false,
  excludedGrandParentIds = []
}) => {
  const svgEl = useRef(null);
  const pathEl = useRef(null);

  const [selectedItem, setSelectedItem] = useState();
  const [selectedCommunity, setSelectedCommunity] = useState();
  const [mousePos, setMousePos] = useState({ x: null, y: null });

  const clickElement = (event, mapElement) => {
    if (!isExcluded(mapElement)) {
      onClick(mapElement, svgEl, event);
    }
  };

  const getWinner = ineId => {
    let win = { partyColor: '#EBEBEB' };
    if (partiesWinners) {
      win = partiesWinners.find(winner => winner.placeId === ineId) || {
        partyColor: '#EBEBEB'
      };
    }
    return win;
  };

  const mouseLeave = (e, mapElement) => {
    setSelectedCommunity('');
    setSelectedItem('');
    setMousePos({ x: null, y: null });
  };

  const mouseEnter = (e, mapElement) => {
    if (!isExcluded(mapElement)) {
      if (allRegions && allRegions.length) {
        setSelectedItem(
          allRegions.find(region => region.ineId === mapElement.parentId).name
        );
      } else {
        setSelectedItem(mapElement.name);
      }
      setSelectedCommunity(mapElement.parentId);
      setMousePos({ x: e.clientX, y: e.clientY });
    }
  };

  const isExcluded = mapElement => {
    return excludedGrandParentIds.some(data => {
      return data === mapElement.parentId;
    });
  };

  return (
    <Fragment>
      <svg
        ref={svgEl}
        className={`map ${className}`}
        viewBox="0 0 511.8 393.8"
        xmlSpace="preserve"
        data-current={currentCommunity}
        data-isselected={currentCommunity !== undefined}
      >
        <g
          ref={pathEl}
          className="svgContainer"
          style={viewVoxStyle}
          fill="none"
        >
          {mapElements &&
            mapElements.map(mapElement => {
              return (
                <CustomG
                  key={`${mapElement.ineId}-${mapElement.name}`}
                  mapElement={mapElement}
                  selectedCommunity={selectedCommunity}
                  selectedPlace={selectedPlace}
                  mouseEnter={mouseEnter}
                  mouseLeave={mouseLeave}
                  getWinner={getWinner}
                  showDots={showDots}
                  clickElement={clickElement}
                />
              );
            })}
        </g>
      </svg>
      {mousePos.x && (
        <div
          className="mapTooltip"
          style={{
            position: 'fixed',
            left: mousePos.x + 15,
            top: mousePos.y - 5
          }}
        >
          {selectedItem}
        </div>
      )}
    </Fragment>
  );
};

SvgMap.propTypes = {
  onClick: PropTypes.func.isRequired,
  whenChange: PropTypes.func,
  selected: PropTypes.string,
  mapElements: PropTypes.arrayOf(PropTypes.shape()),
  className: PropTypes.string,
  mouseEnter: PropTypes.func,
  mouseLeave: PropTypes.func
};

SvgMap.defaultProps = {
  selected: 'all',
  className: '',
  mapElements: []
};

export default SvgMap;
